import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  predictions: null,
  loading: false,
  isFunnelLoading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters } = payload;
  const predictions = data;

  return {
    ...state,
    predictions,
    total,
    filteredTotal,
    filters,
    loading: false,
  };
}

function onLoadFunnelData(state) {
  return {
    ...state,
    isFunnelLoading: true,
  };
}

function onLoadFunnelDataSuccess(state, { payload }) {
  const { chart } = payload;

  return {
    ...state,
    chart,
    isFunnelLoading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_FUNNEL_DATA]: onLoadFunnelData,
  [actions.LOAD_FUNNEL_DATA_SUCCESS]: onLoadFunnelDataSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
